import { Component } from '@angular/core';

@Component({
  selector: 'one-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent {}
